// import React, { useState } from "react";
// import axios from "../../api/axiosAuth";


// // const API_BASE = process.env.REACT_APP_API || "http://localhost:5001/api";

// const API = process.env.REACT_APP_API_BASE || "http://3.236.217.225:5001/api";

// export default function ResponderTarea({ tarea, onRespuestaEnviada }) {
//   const [respuesta, setRespuesta] = useState("");
//   const [archivo, setArchivo] = useState(null);
//   const [enviando, setEnviando] = useState(false);

//   const token = localStorage.getItem("token");
//   const tenant_id = localStorage.getItem("tenant_id");
//   const sede_id = localStorage.getItem("sede_id") || null; // ✅ permite null

//  const handleEnviar = async () => {
//   if (!respuesta.trim() && !archivo) {
//     alert("⚠️ Debes escribir una respuesta o adjuntar un archivo.");
//     return;
//   }

//   setEnviando(true);

//   try {
//     const formData = new FormData();
//     formData.append("task_id", tarea.id);
//     formData.append("respuesta_texto", respuesta);
//     if (archivo) formData.append("archivo", archivo);

//     const { data } = await axios.post(
//       `${API}/tasks/respond`,
//       formData,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data"
//         },
//         withCredentials: true
//       }
//     );

//     alert(data.message || "✅ Tarea respondida correctamente");

//     if (onRespuestaEnviada) onRespuestaEnviada();

//     setRespuesta("");
//     setArchivo(null);
//   } catch (err) {
//     console.error("❌ Error al responder tarea:", err);
//     const msg =
//       err.response?.data?.message ||
//       err.response?.statusText ||
//       "Error desconocido al enviar la tarea";
//     alert(`❌ Error: ${msg}`);
//   } finally {
//     setEnviando(false);
//   }
// };


//   return (
//     <div className="responder-tarea p-4 border rounded-md shadow-sm bg-white">
//       <h3 className="font-bold text-lg mb-2">
//         ✏️ Responder tarea: {tarea.title}
//       </h3>

//       <textarea
//         className="w-full border p-2 rounded-md mb-2"
//         value={respuesta}
//         onChange={(e) => setRespuesta(e.target.value)}
//         placeholder="Escribe tu respuesta aquí..."
//         rows={5}
//       />

//       <input
//         type="file"
//         className="mb-3"
//         onChange={(e) => setArchivo(e.target.files[0])}
//       />

//       <button
//         className="bg-blue-600 text-white px-4 py-2 rounded-md"
//         onClick={handleEnviar}
//         disabled={enviando}
//       >
//         {enviando ? "⏳ Enviando..." : "📤 Enviar respuesta"}
//       </button>
//     </div>
//   );
// }


///
import React, { useState } from "react";
import axios from "../../api/axiosAuth";

/* =========================================
   📘 COMPONENTE: RESPONDER TAREA
========================================= */
export default function ResponderTarea({ tarea, onRespuestaEnviada }) {
  const [respuesta, setRespuesta] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [enviando, setEnviando] = useState(false);

  // NOTA: Ya no necesitamos extraer token ni tenant_id manualmente aquí, 
  // axiosAuth se encarga de los encabezados y la URL base.

  const handleEnviar = async () => {
    if (!respuesta.trim() && !archivo) {
      alert("⚠️ Debes escribir una respuesta o adjuntar un archivo.");
      return;
    }

    setEnviando(true);

    try {
      const formData = new FormData();
      formData.append("task_id", tarea.id);
      formData.append("respuesta_texto", respuesta);
      if (archivo) formData.append("archivo", archivo);

      // 🚀 CORREGIDO: Usamos ruta relativa. 
      // axiosAuth ya sabe que la base es http://3.236.217.225/api
      const { data } = await axios.post(
        "/tasks/respond",
        formData,
        {
          headers: {
            // No es necesario el Authorization aquí, axiosAuth lo inyecta solo
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true
        }
      );

      alert(data.message || "✅ Tarea respondida correctamente");

      if (onRespuestaEnviada) onRespuestaEnviada();

      // Limpiar formulario
      setRespuesta("");
      setArchivo(null);
    } catch (err) {
      console.error("❌ Error al responder tarea:", err);
      const msg =
        err.response?.data?.message ||
        err.response?.statusText ||
        "Error desconocido al enviar la tarea";
      alert(`❌ Error: ${msg}`);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="responder-tarea p-4 border rounded-md shadow-sm bg-white">
      <h3 className="font-bold text-lg mb-2">
        ✏️ Responder tarea: {tarea.title}
      </h3>

      <textarea
        className="w-full border p-2 rounded-md mb-2"
        value={respuesta}
        onChange={(e) => setRespuesta(e.target.value)}
        placeholder="Escribe tu respuesta aquí..."
        rows={5}
      />

      <input
        type="file"
        className="mb-3"
        onChange={(e) => setArchivo(e.target.files[0])}
      />

      <button
        className="bg-blue-600 text-white px-4 py-2 rounded-md"
        onClick={handleEnviar}
        disabled={enviando}
      >
        {enviando ? "⏳ Enviando..." : "📤 Enviar respuesta"}
      </button>
    </div>
  );
}